import { TrashIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { Button, IconButton, Modal } from "../../../../../components/ui";

const ConfirmDelete = props => {
  const { closeModal, onDelete, record } = props || {};
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState(null);

  const handleDelete = async () => {
    setDeleting(true);
    const deleteError = await onDelete(record);
    setDeleting(false);
    if (deleteError) {
      setError(deleteError);
      return;
    }
    closeModal?.();
  };

  return (
    <div className="mt-4 flex flex-col gap-4">
      {error && (
        <div role="alert" className="text-sm text-red-600">
          {error}
        </div>
      )}
      <div className="flex">
        <Button
          className="mr-3"
          label="Cancel"
          action="default"
          onClick={closeModal}
        />
        <Button
          label={deleting ? "Deleting" : "Delete"}
          disabled={deleting}
          onClick={handleDelete}
        />
      </div>
    </div>
  );
};

const DeleteRecordButton = props => {
  const { getDescription, onDelete, record, title } = props || {};

  if (typeof record?.id !== "number") {
    return null;
  }

  const modalProps = {
    title: "Are you sure?",
    scale: "sm",
    description: getDescription(record),
    closeOnBackdrop: true,
    body: ({ closeModal }) => (
      <ConfirmDelete closeModal={closeModal} onDelete={onDelete} record={record} />
    ),
  };

  return (
    <Modal {...modalProps}>
      <IconButton variant="clean" title={title}>
        <TrashIcon className="h-4 w-4 cursor-pointer text-gray-400" />
      </IconButton>
    </Modal>
  );
};

export default DeleteRecordButton;
